import styled, { css } from 'styled-components';
import { GoChevronDown } from 'react-icons/go';
import { HiddenContainer } from '../powerList/styles';
import { RiCloseCircleLine } from 'react-icons/ri';

interface ItemProps {
  readonly mWidth?: string;
  readonly mPadding?: string;
  readonly theme?: string;
  readonly firstActve?: boolean;
  readonly disabled?: boolean;
}

export const DropTitle = styled.span<ItemProps>`
  margin-left: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: ${props => (props.theme === 'gray' ? '16px' : '14px')};
  color: ${props => (props.theme === 'gray' ? '#3E464E' : props.theme === 'dark' ? '#000' : '#5d6e81')};

  ${props => {
    const firstActve = props.firstActve ? `font-weight: 500` : '';
    return css`
       {
        ${firstActve}
      }
    `;
  }}
`;

export const DropLenght = styled.span`
  margin-left: 4px;
  font-size: 14px;
  color: #5d6e81;
`;

export const DropIcon = styled(GoChevronDown) <ItemProps>`
  margin-left: auto;
  color: ${props => (props.theme === 'dark' ? '#000' : '#acb1c0')};
  padding-right: 5px;
  padding-left: 5px;
  font-size: 15px;
`;

export const CloseIcon = styled(RiCloseCircleLine)`
  padding-right: 5px;
  padding-left: 5px;
  margin-left: auto;
  color: #acb1c0;
  cursor: pointer;
  font-size: 21px;
`;

export const DropContainer = styled.div<ItemProps>`
  background-color: rgba(255, 255, 255, 0.92);
  border: 1px solid var(--LightGray);
  display: inline-flex;
  align-items: center;
  position: relative;
  border-radius: 8px;
  min-height: 45px;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  ${props => {
    const mWidth = `min-width: ${props.mWidth};`;
    const mPadding = `padding: ${props.mPadding};`;
    return css`
       {
        ${mWidth}
        ${mPadding}
      }
    `;
  }}

  &:hover ${HiddenContainer} {
    display: ${props => props.disabled ? 'none' : 'block'};
    /* display: block; */
  }
`;

export const DropPermaTitle = styled.span<ItemProps>`
  color: ${props => (props.theme === 'gray' ? '#BAC1C9' : '#5d6e81')};
  font-size: ${props => (props.theme === 'gray' ? '12px' : '14px')};
  font-weight: ${props => (props.theme === 'gray' ? '450' : 'initial')};
  letter-spacing: 0.66px;
`;
